module.exports = __webpack_public_path__ + "static/media/documents_photo.c3cf7709.png";